import { Outlet } from 'react-router-dom';

import { ClubLayout } from 'components/profile/ClubLayout';

const UserTransactionsLayout = () => {
  return (
    <ClubLayout home>
      <Outlet />
    </ClubLayout>
  );
};

export default UserTransactionsLayout;
